import * as React from 'react'

const Feedback = (props: { className: 'string' }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Feedbacks' clipPath='url(#clip0)'>
          <g id='Vector' fillRule='evenodd' clipRule='evenodd'>
            <path
              d='M 3.79289 15.5L 4 15.5L 18 15.5C 18.8239 15.5 19.5 14.8239 19.5 14L 19.5 2C 19.5 1.17614 18.8239 0.5 18 0.5L 2 0.5C 1.17614 0.5 0.5 1.17614 0.5 2L 0.5 18.7929L 3.64645 15.6464L 3.79289 15.5Z'
              transform='translate(4 4)'
              fill='#fff'
            />
            <path
              d='M 3.79289 15.5L 4 15.5L 18 15.5C 18.8239 15.5 19.5 14.8239 19.5 14L 19.5 2C 19.5 1.17614 18.8239 0.5 18 0.5L 2 0.5C 1.17614 0.5 0.5 1.17614 0.5 2L 0.5 18.7929L 3.64645 15.6464L 3.79289 15.5Z'
              strokeMiterlimit='8'
              transform='translate(4 4)'
            />
          </g>
          <g id='Vector_2' fillRule='evenodd' clipRule='evenodd'>
            <path
              d='M 3.79289 15.5L 4 15.5L 18 15.5C 18.8239 15.5 19.5 14.8239 19.5 14L 19.5 2C 19.5 1.17614 18.8239 0.5 18 0.5L 2 0.5C 1.17614 0.5 0.5 1.17614 0.5 2L 0.5 18.7929L 3.64645 15.6464L 3.79289 15.5Z'
              transform='translate(1 1)'
              fill='#666'
            />
            <path
              d='M 3.79289 15.5L 4 15.5L 18 15.5C 18.8239 15.5 19.5 14.8239 19.5 14L 19.5 2C 19.5 1.17614 18.8239 0.5 18 0.5L 2 0.5C 1.17614 0.5 0.5 1.17614 0.5 2L 0.5 18.7929L 3.64645 15.6464L 3.79289 15.5Z'
              strokeMiterlimit='8'
              transform='translate(1 1)'
            />
          </g>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M 2.43478 0L 1.82609 1.91489L 0 1.91489L 1.52174 3.08511L 0.913043 5L 2.43478 3.82979L 3.95652 5L 3.34783 3.08511L 4.86957 1.91489L 3.04348 1.91489L 2.43478 0L 2.43478 0Z'
            transform='translate(3 6)'
            fill='#fff'
            id='Path'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M 2.43478 0L 1.82609 1.91489L 0 1.91489L 1.52174 3.08511L 0.913043 5L 2.43478 3.82979L 3.95652 5L 3.34783 3.08511L 4.86957 1.91489L 3.04348 1.91489L 2.43478 0L 2.43478 0Z'
            transform='translate(8.565 6)'
            fill='#fff'
            id='Path_2'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M 2.43478 0L 1.82609 1.91489L 0 1.91489L 1.52174 3.08511L 0.913043 5L 2.43478 3.82979L 3.95652 5L 3.34783 3.08511L 4.86957 1.91489L 3.04348 1.91489L 2.43478 0L 2.43478 0Z'
            transform='translate(14.13 6)'
            fill='#fff'
            id='Path_3'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Feedback



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Feedback.tsx